import HFormatDate from "@rf-helper/format/format-date";
import { HGetValueFromArray } from "@rf-helper/get-value-from-array";
import HTransformObject from "@rf-helper/transform-object.helper";
import { B_ProjectFormCreateBody } from "@/src-refactor/modules/store/qrtk/services/realestate/values/create-realestate.value";
import prepareOwnersToServer from "./to-server/prepareOwnersToServer";
import prepareSeoToServer from "./to-server/prepareSeoToServer";
import prepareFeaturesToServer from "./to-server/prepareFeaturesToServer";
import prepareVideosToServer from "./to-server/prepareVideosToServer";
import prepareImagesToServer from "./to-server/prepareImagesToServer";
import prepareDocumentsToServer from "./to-server/prepareDocumentsToServer";
import { C_CURRENCY } from "@/src-refactor/modules/shared/model/const/currency.conts";
import prepareBuildingToServer from "./to-server/prepareBuildingToServer";
import prepareValidationToServer from "./to-server/prepareValidationToServer";
import { IPropertyForm } from "../../components/property-form/util/schemas/property-schema/propertySchema";

export const createProjectPayloadAdapter: ICreateProjectPropertyAdapter = (
  state: IPropertyForm
) => {
  const owners = prepareOwnersToServer(state);
  const seo = prepareSeoToServer(state);
  const features = prepareFeaturesToServer(state);
  const videos = prepareVideosToServer(state);
  const images = prepareImagesToServer(state);
  const documents = prepareDocumentsToServer(state);
  const building = prepareBuildingToServer(state);
  const validation = prepareValidationToServer(state);

  const payloadDirty = {
    ...validation,
    features,
    // location
    owners,
    latitude: state.latitude_property,
    longitude: state.longitude_property,
    sector_id: HGetValueFromArray(state.sector_property, "value"),
    city_id: HGetValueFromArray(state.city_property, "value"),
    address: state.address_property,
    reference: state.reference_point_property,

    // bussinessinfo
    realstatetype_id: 14,
    projecttype: HGetValueFromArray(state.type_property, "id"),
    name: state.name_property,
    businesstype_id: HGetValueFromArray(state.business_types_property, "id"),
    condition_status: HGetValueFromArray(state.condition_property, "id"),
    is_no_broker: HGetValueFromArray(state.associates_type_property, "id"),
    brokers: state.brokers_property.map(x => x.value),
    master_broker: state.master_broker_property ? 1 : 0,
    arrangement_id: HGetValueFromArray(state.arrangement_type_property, "id"),
    is_collection: HGetValueFromArray(state.is_collection_property, "id"),
    guaranteed_comission: state.fee_sale_selling_agent_commission_percentage,
    total_comission: state.fee_sale_percentage_commission_property,
    maintenance_fee: state.price_maintenance_property,
    maintenance_currency_id: HGetValueFromArray(
      state.currency_maintenance_property,
      "id"
    ),
    separation_price: state.price_separation_property,
    currency_id: HGetValueFromArray(state.global_currency_property, "id"),
    currency_separation_id: HGetValueFromArray(
      state.currency_separation_property,
      "id"
    ),
    delivers: HFormatDate(state.deadline_property, "back"),
    // seo
    info: seo,

    //documents
    documents,
    // Aunque se usa en edición, lo enviamos siempre por consistencia
    remove_documents: state.remove_documents,
    has_loan: HGetValueFromArray(state.have_mortgage_property, "id"),
    loan_note: state.notes_property,
    property_title_number: state.registration_number
      ? state.registration_number.toString()
      : "",

    // multimedia
    images,
    videos,
    dropbox_link: state.dropbox_link_property,
    google_drive_link: state.drive_link_property,
    realstate_tour_url: state.tour_virtual_property,

    // buildings
    ...building,
    draft_id: state.draft_id
  };
  const payload = HTransformObject(payloadDirty, {
    removeUndefined: true,
    removeEmptyArray: true,
    removeNull: true,
    removeEmptyStrings: true,
    removeEmptyObjects: true
  });
  return payload;
};

type ICreateProjectPropertyAdapter = (
  state: IPropertyForm
) => B_ProjectFormCreateBody;
